import { render, staticRenderFns } from "./ProductDisplay.vue?vue&type=template&id=bc1cf9be&scoped=true"
import script from "./ProductDisplay.vue?vue&type=script&lang=js"
export * from "./ProductDisplay.vue?vue&type=script&lang=js"
import style1 from "./ProductDisplay.vue?vue&type=style&index=1&id=bc1cf9be&prod&lang=css"
import style2 from "./ProductDisplay.vue?vue&type=style&index=2&id=bc1cf9be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1cf9be",
  null
  
)

export default component.exports